import { render, staticRenderFns } from "./blogPage.vue?vue&type=template&id=61fc8942&scoped=true&"
import script from "./blogPage.vue?vue&type=script&lang=ts&"
export * from "./blogPage.vue?vue&type=script&lang=ts&"
import style0 from "./blogPage.vue?vue&type=style&index=0&id=61fc8942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc8942",
  null
  
)

export default component.exports